/**
 * Adds parallax effect to provided elements
 */
export default class Parallaxer {
  /**
   * @param {Object} gsap - GSAP instance to work with
   */
  constructor(gsap) {
    this.gsap = gsap
  }

  /**
   * Add elements to GSAP
   * @param {(NodeList|HTMLCollection)} elements 
   * @param {Object} options 
   * @param {number} speed
   */
  registerElements(elements, speed = 1, toOrigin = false) {
    for (const el of elements) {
      const firstChild = el.children[0]
      if (!firstChild) continue

      const _speed = parseFloat(el.dataset.parallaxSpeed) || speed
      const _toOrigin = el.dataset.parallaxToOrigin || toOrigin
      const offset = 50 * _speed

      this.gsap.set(firstChild, { yPercent: offset })
      this.gsap.to(firstChild, {
        yPercent: _toOrigin ? 0 : -offset,
        ease: 'none',
        scrollTrigger: {
          trigger: el,
          start: 'top bottom',
          end: _toOrigin ? 'center center' : 'bottom top',
          scrub: 1
        }
      })
    }
  }
}